import { AnalyticsOrderFlowTypes, getProductTypeInfo } from '../../common/utils/analytics-util';
import { OrderType } from '../../common/constants/order-types';
import { PaymentOrderDetails } from '../order-confirmation/order-completion.interface';
import { SharpenUpsellPromoAnalytics } from './interfaces/sharpen-upsell.interface';
import { StoreState } from '../../store/store.interface';
import { getCart, getPromoCodeState } from '../cart/shop-cart/store/shop-cart.selectors';

/**
 * Returns analytics overrides when the order contains a Sharpen Plus product and a coupon code starting with "MH".
 *
 * @param programSourceIds
 * @param couponCode
 */
export function getSharpenPromoAnalytics(
  programSourceIds: string[],
  couponCode?: string
): Partial<SharpenUpsellPromoAnalytics> {
  const hasSharpenPlus = programSourceIds.some(
    (programSourceId) => !!getProductTypeInfo({ programId: programSourceId }).productType
  );

  if (hasSharpenPlus && hasSharpenPromoCode(couponCode)) {
    return getSharpenPromoAnalyticsValues();
  }

  return {};
}

export function getSharpenPromoAnalyticsValues(): SharpenUpsellPromoAnalytics {
  return {
    orderType: OrderType.HE_CONNECT,
    orderFlow: AnalyticsOrderFlowTypes.HE_CONNECT_SHARPEN_PROMO,
  };
}

export function getSharpenPromoAnalyticsFromCart(state: StoreState): Partial<SharpenUpsellPromoAnalytics> {
  return getSharpenPromoAnalytics(
    getCart(state)?.products?.map((p) => p.productIdentifier?.programSourceId ?? '') ?? [],
    getPromoCodeState(state)?.coupon
  );
}

export function getSharpenPromoAnalyticsFromOrderCompletion(
  order: PaymentOrderDetails
): Partial<SharpenUpsellPromoAnalytics> {
  return getSharpenPromoAnalytics(
    order.orderItems?.map((p) => p.productMetaData?.programSourceId ?? '') ?? [],
    order.promocode
  );
}

export function hasSharpenPromoCode(couponCode?: string): boolean {
  return !!couponCode?.toUpperCase().startsWith('MH');
}
